import { render, staticRenderFns } from "./ManageDocumentAccess.vue?vue&type=template&id=3f07d044&scoped=true"
import script from "./ManageDocumentAccess.vue?vue&type=script&lang=js"
export * from "./ManageDocumentAccess.vue?vue&type=script&lang=js"
import style0 from "./ManageDocumentAccess.vue?vue&type=style&index=0&id=3f07d044&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07d044",
  null
  
)

export default component.exports